import { Component, type ErrorInfo, type ReactNode } from "react";
import { newIssueReference, reportClientIssue } from "../observability/client-events";

interface AppErrorBoundaryProps { children: ReactNode; }
interface AppErrorBoundaryState { reference: string | null; }

export class AppErrorBoundary extends Component<AppErrorBoundaryProps, AppErrorBoundaryState> {
  state: AppErrorBoundaryState = { reference: null };

  static getDerivedStateFromError(): AppErrorBoundaryState {
    return { reference: newIssueReference() };
  }

  componentDidCatch(_error: Error, _info: ErrorInfo) {
    if (!this.state.reference) return;
    void reportClientIssue({ reference: this.state.reference, area: "app.unexpected", kind: "unexpected" });
  }

  render() {
    if (!this.state.reference) return this.props.children;
    return (
      <main className="app-recovery" role="alert">
        <div>
          <p className="eyebrow">Workspace recovery</p>
          <h1>The workspace hit a snag.</h1>
          <p>Your last local save is still available. Reload the workspace to continue.</p>
          <button className="primary-button" type="button" onClick={() => window.location.reload()}>Reload workspace</button>
        </div>
      </main>
    );
  }
}
